import React from "react";
import {
  Header,
  Grid,
  Button,
  Table,
  Segment,
  Icon,
  Divider,
  Message,
} from "semantic-ui-react";
import { isValidChildPartNumber } from "../../../../validation/validateSupplyPartNumber";
import { SupplyUnitSearch } from "../../../search/SupplyUnitSearch"; // Adjust import path
import "../index.css";

export function SearchAddPage({
  masterSupplyUnits,
  supplyUnits,
  setSupplyUnits,
  product,
  onSubmit,
  onClose,
}) {
  const allValidSupplyUnits = supplyUnits.every((unit) => {
    return isValidChildPartNumber(product.partNumber, unit.part_number);
  });

  // Create combined list of existing supply units for the search component
  const existingSupplyUnits = [...supplyUnits, ...masterSupplyUnits];

  // Handle adding supply units from the search component
  const handleSupplyUnitsAdd = (newSupplyUnits) => {
    setSupplyUnits((prev) => [...prev, ...newSupplyUnits]);
  };

  const handleRemoveUnit = (upc) => {
    setSupplyUnits((prev) => prev.filter((unit) => unit.upc !== upc));
  };

  return (
    <div>
      <Header as="h3">Add Supply Units</Header>
      <p>Add existing supply units for this product by UPC or Title.</p>

      <SupplyUnitSearch
        existingSupplyUnits={existingSupplyUnits}
        onSupplyUnitsAdd={handleSupplyUnitsAdd}
        placeholder="Search by UPC or Title"
        minCharacters={2}
        className="scrolling-search"
        fluid
      />

      {supplyUnits.length > 0 && (
        <Segment basic>
          {/* Add warning message when supply units have invalid part numbers */}
          {!allValidSupplyUnits && supplyUnits.length > 0 && (
            <Message
              error
              icon="exclamation triangle"
              header="Invalid Part Numbers Detected"
              content="All supply units must have valid part numbers before proceeding. Please remove invalid units or update their part numbers."
            />
          )}
          <Table basic>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>UPC</Table.HeaderCell>
                <Table.HeaderCell>Title</Table.HeaderCell>
                <Table.HeaderCell>Part Number</Table.HeaderCell>
                <Table.HeaderCell />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {supplyUnits.map((unit) => (
                <Table.Row
                  key={unit.upc}
                  warning={
                    !isValidChildPartNumber(
                      product.partNumber,
                      unit.part_number
                    )
                  }
                >
                  <Table.Cell>{unit.upc}</Table.Cell>
                  <Table.Cell>{unit.supply_title.slice(0, 100)}</Table.Cell>
                  <Table.Cell>
                    {unit.part_number}
                    {!isValidChildPartNumber(
                      product.partNumber,
                      unit.part_number
                    ) && (
                      <Icon
                        name="warning sign"
                        color="red"
                        title="Invalid part number"
                      />
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    <Icon
                      title="Remove unit from selection"
                      name="trash alternate"
                      color="red"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleRemoveUnit(unit.upc)}
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Segment>
      )}
      <Divider hidden />
      <Grid>
        <Grid.Row>
          <Grid.Column floated="left" width={5}>
            <Button type="button" onClick={onClose}>
              Close
            </Button>
          </Grid.Column>
          <Grid.Column floated="right" width={5} textAlign="right">
            <Button
              primary
              type="button"
              onClick={onSubmit}
              disabled={supplyUnits.length === 0 || !allValidSupplyUnits}
            >
              Add
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
}
